var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "form-info" }, [
      _c("div", { staticClass: "form-row" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.tradeVoucher.sellerName))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.tradeVoucher.servicer.contactName))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.tradeVoucher.servicer.contactTel))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.tradeVoucher.servicer.servicerCom.regionName))
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _c("div", { staticClass: "form-info a" }, [
      _c("div", { staticClass: "form-row" }, [
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.tradeVoucher.buyerName))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(7),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.tradeVoucher.retailerCom.contactTel))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(8),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.tradeVoucher.retailerCom.regionName))
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(9),
    _vm._v(" "),
    _c("div", { staticClass: "form-info a" }, [
      _c(
        "div",
        { staticClass: "examine-title" },
        [
          _c("span", { staticClass: "mr10" }, [_vm._v("审核结果")]),
          _vm._v(" "),
          _vm._l(_vm.auditStateList, function(auditState) {
            return _c(
              "el-radio",
              {
                staticClass: "radio",
                attrs: { label: auditState.value },
                model: {
                  value: _vm.auditStateValue,
                  callback: function($$v) {
                    _vm.auditStateValue = $$v
                  },
                  expression: "auditStateValue"
                }
              },
              [_vm._v(_vm._s(auditState.text))]
            )
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "examine-item" }, [
      _c(
        "div",
        {
          staticClass: "examine-content",
          staticStyle: { "padding-left": "0" }
        },
        [
          _c("div", { staticClass: "form-info" }, [
            _c(
              "div",
              {
                staticClass: "form-row",
                staticStyle: { "line-height": "90px" }
              },
              [
                _vm._m(10),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.auditDesc,
                        expression: "auditDesc"
                      }
                    ],
                    staticClass: "width-2x",
                    attrs: { placeholder: "审核描述" },
                    domProps: { value: _vm.auditDesc },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.auditDesc = $event.target.value
                      }
                    }
                  })
                ])
              ]
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("卖家信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("公司名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("联系人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("联系电话")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("所在地址")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [
        _c("span", { staticClass: "color-laber" }),
        _vm._v("买方信息")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("零售商名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("零售商联系方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("零售商地址")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_c("span", { staticClass: "color-laber" }), _vm._v("审核")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "form-label", staticStyle: { width: "auto" } },
      [_c("label", { staticClass: "font-bold" }, [_vm._v("审核描述")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fa8404e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fa8404e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/tradeVoucher/TradeVoucherCheck.vue
// module id = 1839
// module chunks = 1